import { useCallback } from "react";
import { SlidersHorizontal } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import {
  invalidateCustomFieldGroupsTableQuery,
  useCustomFieldGroupsTable,
} from "hooks/useCustomFieldGroupsTable";
import CustomFieldGroupsService from "services/CustomFieldGroups";
import CustomFieldGroupModal from "./components/CustomFieldGroupModal";

export const CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS = {
  tableName: "custom_field_groups",
  queryKey: "custom_field_group",
  className: "CustomFieldGroup",
  header: "Custom Field Groups",
  headerIcon: SlidersHorizontal,
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.customFieldGroup.create];

const CustomFieldGroupsTableV3 = () => {
  const { filters, columns } = useCustomFieldGroupsTable({
    tableName: CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.tableName,
  });

  const fetchCustomFieldGroups = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        let response =
          await CustomFieldGroupsService.getCustomFieldGroups(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching custom field groups:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      queryKey={CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.queryKey}
      className={CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.className}
      tableName={CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.tableName}
      header={CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.header}
      headerIcon={CUSTOM_FIELD_GROUPS_TABLE_CONSTANTS.headerIcon}
      enableSearch
      enableSettings
      fetchData={fetchCustomFieldGroups}
      invalidateData={invalidateCustomFieldGroupsTableQuery}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <CustomFieldGroupModal
            onSuccess={invalidateCustomFieldGroupsTableQuery}
          />
        </Authorized>
      }
    />
  );
};

export default CustomFieldGroupsTableV3;
